import { get } from "lodash"
import { createQueryStringSelector } from "selectors/queryString"

export const getEmailSent = state => get(state, "modules.forgotPassword.emailSent")
export const getErrorMessage = state => get(state, "modules.forgotPassword.error")
export const getEmail = createQueryStringSelector("email")
